import React from 'react';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router';

const CancelButton = () => {
  const history = useHistory();

  return (
    <Button variant="contained" onClick={() => history.goBack()}>
      Cancel
    </Button>
  );
};
export default CancelButton;
